import React, { useState, useEffect } from "react";
import { List, Modal, Image, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";

import { DragHandle } from "../../../../../components/DragHandle";
import Imageurldata from "../../../../../Imageurldata";

const RecipeVideoOrdering = ({ isOpen, onClose, recipeVideos, base_url }) => {
  const [videoList, setVideoList] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= INIT ================= */
  useEffect(() => {
    if (isOpen) {
      setVideoList(recipeVideos || []);
    }
  }, [isOpen, recipeVideos]);

  /* ================= UPDATE ORDER ================= */
  const handleOrderUpdate = async (updatedList) => {
    setLoading(true);
    try {
      // Get unique parent RECIPE IDs and assign new positions
      const uniqueRecipes = Array.from(
        new Set(updatedList.map((item) => item.parentId))
      ).map((id, index) => ({
        _id: id,
        position: index,
      }));

      await axios.post(`${base_url}/recipe/video/reorder`, {
        order: uniqueRecipes,
      });

      notification.success({
        message: "Recipe video order updated successfully",
      });

      onClose(true);
    } catch (err) {
      notification.error({
        message: "Failed to update order",
        description: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Reorder Recipe Videos"
      visible={isOpen}
      onOk={() => handleOrderUpdate(videoList)}
      okText="Update Order"
      confirmLoading={loading}
      onCancel={() => onClose(false)}
      width={600}
    >
      <DragDropContext
        onDragEnd={(result) => {
          const srcIndex = result.source.index;
          const destIndex = result.destination?.index;
          if (destIndex === undefined) return;

          const tempList = [...videoList];
          tempList.splice(destIndex, 0, tempList.splice(srcIndex, 1)[0]);
          setVideoList(tempList);
        }}
      >
        <Droppable droppableId="droppable-recipe-videos">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ maxHeight: 400, overflowY: "auto" }}
            >
              <List
                bordered
                dataSource={videoList}
                renderItem={(item, index) => (
                  <Draggable
                    key={item._id}
                    draggableId={item._id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          ...provided.draggableProps.style,
                          boxShadow: snapshot.isDragging
                            ? "0 0 .4rem #666"
                            : "none",
                          marginBottom: 8,
                          borderRadius: 4,
                          background: "#fff",
                        }}
                      >
                        <List.Item>
                          <Image
                            src={
                              Imageurldata +
                              item.desktopImageUrl.replaceAll("\\", "/")
                            }
                            width={50}
                            height={50}
                            style={{
                              objectFit: "cover",
                              borderRadius: 4,
                              marginRight: 10,
                            }}
                            fallback="/no-image.png"
                          />

                          <span>{item.title}</span>

                          <DragHandle {...provided.dragHandleProps} />
                        </List.Item>
                      </div>
                    )}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default RecipeVideoOrdering;
